
import eventBus from '../plugins/eventBus'
import { Component, Vue } from 'vue-property-decorator'
import { getParameter } from '@/plugins/globals'
import { CategoriesStore } from '@/store/stores/CategoriesStore'

@Component({})
export default class MainHeaderCategory extends Vue {
  show: boolean = false
  categories: CategoriesStore = CategoriesStore.getInstance()

  selectCategory(category: any, event: any) {
    event.stopPropagation()
    this.show = false
    eventBus.$emit('categories:selected', category.id)
  }

  showCategories() {
    this.show = !this.show
  }

  mounted() {
    const sectorId = getParameter('sector_id')
    this.categories.loadData(sectorId)
  }
}
